import React from 'react'
import { Modal, Pressable } from 'react-native'

import { Stack } from '@zet/design-system'
import { useBackHandler } from '@zet/design-system/hooks'

interface IModalBottomSheet {
  visible: boolean
  onDismiss: () => void
  sheetName?: string
  children?: React.ReactNode
}

const ModalBottomSheet = ({
  visible,
  onDismiss,
  sheetName,
  children,
  ...props
}: IModalBottomSheet) => {
  useBackHandler(() => {
    if (visible) {
      onDismiss()
      return true
    }
    return false
  })

  return (
    <Modal
      animationType="slide"
      transparent={true}
      visible={visible}
      onRequestClose={onDismiss}
      {...props}
    >
      <Pressable
        style={{
          backgroundColor: 'rgba(0,0,0,0.5)',
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
        }}
        onPress={onDismiss}
      >
        <Pressable
          onPress={(event) => event.preventDefault()}
          className="bg-neutral-white100 w-full rounded-t-2xl"
          style={{
            position: 'absolute',
            bottom: 0,
            width: '100%',
          }}
        >
          <Stack>{children}</Stack>
        </Pressable>
      </Pressable>
    </Modal>
  )
}

export default ModalBottomSheet
